import { SvgIcon } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { FC, memo } from 'react';

type Props = {
  size?: number;
  color?: string;
  style?: {
    fontSize: string;
  };
};
const useStyles = makeStyles()(() => ({
  root: {
    // アイコンサイズを指定, materiau-ui のrootを上書き
    fontSize: '32px',
  },
}));

const CheckedIcon: FC<React.PropsWithChildren<Props>> = (props) => {
  const { size } = props;
  const { classes } = useStyles();
  return (
    <SvgIcon classes={{ root: classes.root }}>
      <svg id="CheckedIcon" xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48">
        <g id="グループ_390" data-name="グループ 390" transform="translate(-12 -13)">
          <g id="GroupSelectBox" transform="translate(12 13)" fill="#fff" stroke="#000" strokeWidth="1">
            <rect width="48" height="48" rx="8" stroke="none" />
            <rect x="0.5" y="0.5" width="47" height="47" rx="7.5" fill="none" />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default memo(CheckedIcon);
